import { DEFAULT_TIMEOUT } from "../core/constants";
import { StartPayError } from "../core/errors";
import { createTimeoutSignal } from "./timeout";

export type JsonRequestOptions = {
  method?: "GET" | "POST";
  body?: unknown;
  headers?: Record<string, string>;
  timeout?: number;
  signal?: AbortSignal;
};

export const requestJson = async <T>(url: string, options: JsonRequestOptions = {}): Promise<T> => {
  const timeout = createTimeoutSignal(options.timeout ?? DEFAULT_TIMEOUT, options.signal);

  try {
    const response = await fetch(url, {
      method: options.method ?? "POST",
      headers: {
        "content-type": "application/json",
        ...options.headers
      },
      body: options.body === undefined ? undefined : JSON.stringify(options.body),
      signal: timeout.signal
    });

    const text = await response.text();
    const data = text ? JSON.parse(text) : undefined;

    if (!response.ok) {
      throw new StartPayError(
        data?.message ?? `Request failed with status ${response.status}`,
        data?.errorCode ?? "REQUEST_FAILED",
        data
      );
    }

    return data as T;
  } catch (error) {
    if (timeout.signal.aborted) {
      throw new StartPayError("Payment request timed out", "REQUEST_TIMEOUT", error);
    }
    throw error;
  } finally {
    timeout.clear();
  }
};
